<template>
	<el-card class="messagePush clearfloat">
		<!-- 搜索框 -->
		<el-form
			ref="tableFilter"
			class="filterForm"
			inline
			:model="tableFilter"
		>
			<el-form-item prop="pusher">
				<el-input
					size="small"
					v-model="tableFilter.pusher"
					placeholder="推送人"
				></el-input>
			</el-form-item>
			<el-form-item prop="type">
				<el-select
					size="small"
					v-model="tableFilter.type"
					placeholder="用户范围"
					clearable
				>
					<el-option
						v-for="item in $staticData.userScopes"
						:key="item.value"
						:value="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="clickType">
				<el-select
					size="small"
					v-model="tableFilter.clickType"
					placeholder="点击动作"
					clearable
				>
					<el-option
						v-for="item in $staticData.msgClickTypes"
						:key="item.value"
						:value="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="pushStartTime">
				<el-date-picker
					v-model.trim="filterDate"
					:picker-options="pickerOptions"
					type="datetimerange"
					size="small"
					start-placeholder="推送开始时间"
					end-placeholder="推送结束时间"
				></el-date-picker>
			</el-form-item>
			<el-form-item prop="brand">
				<el-select
					size="small"
					v-model="tableFilter.brand"
					placeholder="APP来源"
					clearable
				>
					<el-option
						v-for="item in sources"
						:key="item.value"
						:value="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button size="small" @click="handleResetFilter">
					重置
				</el-button>
				<el-button type="primary" size="small" @click="getList">
					搜索
				</el-button>
			</el-form-item>
		</el-form>
		<!-- 操作栏 -->
		<el-button
			class="right"
			type="primary"
			size="small"
			v-if="btnPer('com_addPushRecord')"
			@click="handleAdd"
		>
			添加
		</el-button>
		<!-- 表格 -->
		<el-table :data="tableData" style="width: 100%">
			<el-table-column
				width="50"
				fixed="left"
				label="序号"
				type="index"
			></el-table-column>
			<el-table-column
				width="200"
				fixed="left"
				label="标题"
				prop="title"
			></el-table-column>
			<!-- APP来源 -->
			<el-table-column
				label="APP来源"
				width="150"
				prop="brand"
				:formatter="
					(row, column, cellValue, index) => escapeSource(cellValue)
				"
			></el-table-column>
			<!-- 平台 -->
			<el-table-column
				width="120"
				label="平台"
				prop="platform"
				:formatter="(row) => $utils.escapePlatforms(row.platform)"
			></el-table-column>
			<!-- 内容 -->
			<el-table-column width="200px" label="内容" prop="content">
				<template slot-scope="scope">
					<el-tooltip
						:disabled="scope.row.content.length < 12"
						:content="scope.row.content"
					>
						<span>{{
							$utils.handleDealLongTxt(scope.row.content)
						}}</span>
					</el-tooltip>
				</template>
			</el-table-column>
			<!-- 推送方式 -->
			<el-table-column width="250" label="推送方式" prop="clickType">
				<template slot-scope="scope">
					<span>{{
						$utils.escapePushType(scope.row.clickType)
					}}</span>
				</template>
			</el-table-column>
			<!-- 用户范围 -->
			<el-table-column
				label="用户范围"
				prop="type"
				:formatter="
					(row, column, cellValue, index) =>
						$utils.escapeUserScope(cellValue)
				"
			></el-table-column>
			<!-- 推送人 -->
			<el-table-column label="推送人" prop="pusher"></el-table-column>
			<!-- 推送时间 -->
			<el-table-column width="200" label="推送时间" prop="pushTime">
				<template slot-scope="scope">
					<span>{{ $utils.formatDate(scope.row.pushTime) }}</span>
				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column
				fixed="right"
				width="150"
				:min-width="120"
				label="操作"
			>
				<template slot-scope="scope">
					<el-link
						type="primary"
						size="small"
						v-if="btnPer('com_checkPushRecord')"
						class="marginR10"
						@click="handleInfo(scope.row)"
					>
						查看
					</el-link>
					<el-link
						type="danger"
						size="small"
						v-if="btnPer('com_deletePushRecord')"
						@click="handleDelete(scope.row)"
					>
						删除
					</el-link>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination
			class="pagination marginT20"
			align="right"
			@size-change="(pageSize) => getList('pageSize', pageSize, true)"
			@current-change="(page) => getList('pageNumber', page)"
			:current-page.sync="tableFilter.pageNumber"
			:page-sizes="[10, 20, 30, 40]"
			:page-size.sync="tableFilter.pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
		></el-pagination>
		<!-- 新增表单 -->
		<el-dialog
			title="添加"
			:visible.sync="dialogVisible"
			width="80"
			@close="handleClose"
		>
			<!-- 表单 -->
			<el-form
				ref="form"
				inline
				:model="form"
				label-width="150px"
				:rules="rules"
			>
				<!-- 标题 -->
				<el-form-item label="标题" prop="title">
					<el-input
						size="small"
						class="formInput"
						:disabled="act == 'info'"
						v-model="form.title"
					></el-input>
				</el-form-item>
				<!-- 平台 -->
				<el-form-item label="平台" prop="platform">
					<el-select
						:disabled="act == 'info'"
						size="small"
						v-model="form.platform"
						@change="handlePlatformChange"
					>
						<el-option
							v-for="item in $staticData.platforms"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- 产品类型 -->
				<el-form-item
					v-show="form.clickType == 2"
					label="产品类型"
					prop="deviceType"
				>
					<!-- 定制 -->
					<el-select
						placeholder=" "
						:disabled="form.platform == null || act == 'info'"
						v-if="form.platform == 1"
						size="small"
						v-model="form.deviceType"
						@change="getProductModels"
					>
						<el-option
							v-for="(item, idx) in $store.state.oldStore
								.deviceTypes"
							:key="idx"
							:value="item"
							:label="item"
						></el-option>
					</el-select>
					<!-- 标准 -->
					<el-select
						v-else
						placeholder=" "
						size="small"
						v-model="form.deviceType"
						:disabled="form.platform == null || act == 'info'"
						@change="getProductModels"
					>
						<el-option
							v-for="item in deviceTypes"
							:key="item.id"
							:value="item.id"
							:label="item.productType"
							:disabled="item.tagId != 1"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- 产品型号 -->
				<el-form-item
					v-show="form.clickType == 2"
					label="产品型号"
					prop="deviceModel"
				>
					<!-- 定制化 -->
					<el-select
						v-if="form.platform == 1"
						size="small"
						placeholder=" "
						v-model="form.deviceModel"
						:disabled="form.deviceType == null || act == 'info'"
					>
						<el-option
							v-for="(item, idx) in $store.state.oldStore.types[
								form.deviceType
							]"
							:key="idx"
							:value="item"
							:label="item"
						></el-option>
					</el-select>
					<!-- 标准化 -->
					<el-select
						v-else
						size="small"
						v-model="form.deviceModel"
						placeholder=" "
						:disabled="form.deviceType == null || act == 'info'"
					>
						<el-option
							v-for="item in deviceModels"
							:key="item.id"
							:value="item.id"
							:label="item.productModel"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- APP来源 - 字段修改过，字段名称用的是brands 值为APP来源(sources) -->
				<el-form-item label="APP来源" prop="brand">
					<el-select
						placeholder="APP来源"
						size="small"
						v-model="form.brand"
					>
						<el-option
							v-for="item in sources"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- 用户范围 -->
				<el-form-item label="用户范围" prop="type">
					<el-select
						size="small"
						v-model="form.type"
						:disabled="act == 'info'"
					>
						<el-option
							v-for="item in $staticData.userScopes"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- 推送方式 -->
				<el-form-item class="block" label="推送方式" prop="clickType">
					<el-select
						size="small"
						class="longSelect"
						v-model="form.clickType"
						:disabled="act == 'info'"
					>
						<el-option
							v-for="item in $staticData.msgClickTypes"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
					<el-input
						class="marginT10"
						v-if="form.clickType == 3"
						v-model="form.url"
						placeholder="https://xxxx"
					></el-input>
				</el-form-item>
				<!-- 内容 -->
				<el-form-item label="内容" prop="content" class="block">
					<el-input
						type="textarea"
						v-model="form.content"
						:disabled="act == 'info'"
						:rows="5"
						style="width: 400px"
					></el-input>
				</el-form-item>
			</el-form>
			<span v-if="act != 'info'">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确认</el-button>
			</span>
		</el-dialog>
		<!-- 详情表单 -->
		<el-dialog title="查看" :visible.sync="dialogInfo" width="80">
			<!-- bianji -->
			<el-form ref="form" label-width="150px" :rules="rules">
				<!-- 标题 -->
				<el-form-item label="标题" prop="title">
					<span>{{ formInfo.title }}</span>
				</el-form-item>
				<!-- 平台 -->
				<el-form-item label="平台" prop="platform">
					<span>{{ $utils.escapePlatforms(formInfo.platform) }}</span>
				</el-form-item>
				<!-- 产品类型 -->
				<el-form-item
					v-show="formInfo.clickType == 2"
					label="产品类型"
					prop="deviceType"
				>
					<span>{{ escapeProductType(formInfo) }}</span>
				</el-form-item>
				<!-- 产品型号 -->
				<el-form-item
					v-show="formInfo.clickType == 2"
					label="产品型号"
					prop="deviceModel"
				>
					<span>{{ escapeProductModel(formInfo) }}</span>
				</el-form-item>
				<!-- APP来源 -->
				<el-form-item label="APP来源" prop="brand">
					<span>{{ escapeSource(formInfo.brand) }}</span>
				</el-form-item>
				<!-- 用户范围 -->
				<el-form-item label="用户范围" prop="type">
					<span>{{ $utils.escapeUserScope(formInfo.type) }}</span>
				</el-form-item>
				<!-- 推送方式 -->
				<el-form-item class="block" label="推送方式" prop="clickType">
					<span>{{
						$utils.escapeAdvClickType(formInfo.clickType)
					}}</span>
				</el-form-item>
				<!-- 内容 -->
				<el-form-item label="内容" prop="content" class="block">
					<span>{{ formInfo.content }}</span>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-card>
</template>

<script>
export default {
	name: "messagePush",
	data() {
		var checkClickType = (rule, value, callback) => {
			if (value == 1 || value == 2) {
				callback();
			} else if (value == 3) {
				if (this.$utils.checkUrl(this.form.url)) {
					callback();
				} else {
					callback(new Error("请输入正确的网址"));
				}
			} else {
				callback(new Error("请选择推送方式"));
			}
		};
		var checkProduct = (rule, value, callback) => {
			let type = this.form.clickType;
			if (type == 1 || type == 3) {
				callback();
			} else {
				if (value == null) {
					callback(new Error("请输入选择产品"));
				} else {
					callback();
				}
			}
		};
		return {
			// ——————————————————————————
			dialogVisible: false,
			dialogInfo: false,
			filterDate: null,
			total: 0,
			act: "",
			pickerOptions: {
				//只允许选择今天之前的日期(包括今天)
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			form: {
				platform: null,
				brand: null,
				deviceType: null,
				deviceModel: null,
				content: "",
				title: "",
				url: "",
				type: null,
				clickType: "",
			},
			formInfo: {},
			tableFilter: {
				pushStartTime: null,
				pushEndTime: null,
				brand: null,
				type: null,
				clickType: null,
				pageNumber: 1,
				pageSize: 10,
			},
			rules: {
				platform: [
					{
						required: true,
						message: "请选择平台",
						trigger: "blur",
					},
				],
				deviceType: [
					{
						validator: checkProduct,
						trigger: "blur",
						required: true,
					},
				],
				deviceModel: [
					{
						validator: checkProduct,
						trigger: "blur",
						required: true,
					},
				],
				brand: [
					{
						required: true,
						message: "请选择APP来源",
						trigger: "blur",
					},
				],
				type: [
					{
						required: true,
						message: "请选择用户范围",
						trigger: "blur",
					},
				],
				title: [
					{
						required: true,
						message: "请输入标题",
						trigger: "change",
					},
				],
				content: [
					{
						required: true,
						message: "请输入内容",
						trigger: "blur",
					},
				],
				clickType: [
					{ validator: checkClickType, trigger: "change" },
					{
						required: true,
						message: "请输入内容",
						trigger: "blur",
					},
				],
			},
			sources: [],
			deviceTypes: [],
			deviceModelAll: [],
			deviceModels: [], // 产品型号列表-表单用
			tableData: [],
		};
	},
	watch: {
		filterDate: function (val, oldVal) {
			if (!val) {
				this.tableFilter.pushStartTime = null;
				this.tableFilter.pushEndTime = null;
			} else {
				this.tableFilter.pushStartTime = this.$utils.formatDate(val[0]);
				this.tableFilter.pushEndTime = this.$utils.formatDate(val[1]);
			}
		},
	},
	created() {
		this.getList();
		this.getSource();
		this.getProductTypes();
		this.getProductModelAll();
	},
	methods: {
		getList: function (type, val, isReload = false) {
			isReload ? this.tableFilter.pageNumber = 1 : null;
			if (type) {
				this.tableFilter[type] = val;
			}
			this.$http.messagePushs(this.tableFilter).then((res) => {
				this.tableData = res.data.rows;
				this.total = res.data.total;
			});
		},
		// 添加
		handleAdd: function () {
			this.dialogVisible = true;
			this.act = "add";
		},
		// 查看
		handleInfo: function (row) {
			this.dialogInfo = true;
			this.act = "info";
			this.$nextTick(() => {
				this.formInfo = Object.assign({}, row);
			});
		},
		// 删除
		handleDelete: function (row) {
			this.$confirm("确认删除此教程（" + row.title + "）吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$http.deleteMessagePush(row.id).then((res) => {
					this.getList();
				});
			});
		},
		// 提交表单
		handleSubmit: function () {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.$http.addMessagePush(this.form).then((res) => {
						if (res.data.success) {
							this.getList();
							this.handleClose();
						}
					});
				}
			});
		},
		// 关闭表单
		handleClose: function () {
			this.dialogVisible = false;
			this.$refs.form.resetFields();
		},
		// 重置筛选表单
		handleResetFilter: function () {
			this.$refs.tableFilter.resetFields();
			this.filterDate = null;
		},
		// 当平台修改时
		handlePlatformChange: function () {
			this.form.deviceType = null;
			this.form.deviceModel = null;
		},
		// ———————————— 获取关联数据 ————————————
		// 获取产品类型列表
		getProductTypes: function () {
			this.$http.productTypesAll().then((res) => {
				if (res.data.success) {
					this.deviceTypes = res.data.data;
				}
			});
		},
		// 获取产品型号列表
		getProductModelAll: function () {
			this.$http.productModuleAll().then((res) => {
				if (res.data.success) {
					this.deviceModelAll = res.data.data;
				}
			});
		},
		// 获取产品型号列表
		getProductModels: function () {
			if (this.form.platform == 2) {
				this.$http
					.productModuleAll({
						productType: this.form.deviceType,
					})
					.then((res) => {
						if (res.data.success) {
							this.deviceModels = res.data.data;
						}
					});
			}
		},
		// 处理数据转译
		escapeProductType: function (formInfo) {
			let list = Object.assign([], this.deviceTypes);
			if (formInfo.id) {
				if (formInfo.platform == 1) {
					return formInfo.deviceType;
				} else {
					for (let i in list) {
						if (list[i].id == formInfo.productTypeId) {
							return list[i].productType;
						}
					}
				}
			} else {
				return "--";
			}
		},
		// 处理数据转译
		escapeProductModel: function (formInfo) {
			let list = Object.assign([], this.deviceModelAll);
			if (formInfo.id) {
				if (formInfo.platform == 1) {
					return formInfo.deviceModel;
				} else {
					for (let i in list) {
						if (list[i].id == formInfo.productId) {
							return list[i].productModel;
						}
					}
				}
			} else {
				return "--";
			}
		},
		// 转译APP来源
		escapeSource(val) {
			for (let i in this.sources) {
				if (this.sources[i].value == val) {
					return this.sources[i].label;
				}
			}
		},
		// 获取APP来源
		getSource() {
			this.$http.sources().then((res) => {
				if (res.data && res.data.success) {
					let list = [];
					for (let i in res.data.data) {
						list.push({
							value: Number(res.data.data[i].code),
							label: res.data.data[i].name,
						});
					}
					this.sources = list;
				}
			});
		},
		// 判断按钮权限
		btnPer: function (name) {
			let list = this.$store.state.standard.menuNodeList,
				flag = false;
			for (let i in list) {
				if (list[i].href == name) {
					flag = true;
					break;
				}
			}
			return flag;
		},
	},
};
</script>

<style lang="less" scoped>
.mce {
	height: 700rpx;
}
.formInput {
	width: 200px;
}
.filterForm {
	display: inline-block;
	width: 90%;
}
.longSelect {
	width: 300px;
}
</style>
